import Paragraph from '../../Typography/Paragraph/Paragraph'
import React, { useMemo } from 'react'
import { DetectionListItem } from '../helper'

interface ColorItem {
    color: string;
    pixel_percentage: number;
}

interface FieldConfig {
    uid: string;
    title?: string;
    type: string;
    threshold?: boolean;
    threshold_value?: number;
    hidden?: boolean;
    showConfidence?: boolean;
}

type ListColorProps = {
    field: FieldConfig;
    bgColor: ColorItem[];
    dominantColors: ColorItem[];
    threshold_value?: number;
    showAll?: boolean;
    showConfidence?: boolean;
}

const ListColor = ({ field, bgColor, dominantColors, threshold_value, showAll }: ListColorProps) => {

    const sortedBgColor = useMemo(() => {
        if (!bgColor || !Array.isArray(bgColor)) return bgColor;
        return [...bgColor].sort((a, b) => (b.pixel_percentage || 0) - (a.pixel_percentage || 0));
    }, [bgColor]);

    const sortedDominantColors = useMemo(() => {
        if (!dominantColors || !Array.isArray(dominantColors)) return dominantColors;
        return [...dominantColors].sort((a, b) => (b.pixel_percentage || 0) - (a.pixel_percentage || 0));
    }, [dominantColors]);

    return (
        <div className='Sidebar__list-color'>
            <ColorContainer
                title={`Background Colors (${sortedBgColor.filter((color) => color.pixel_percentage >= threshold_value).length || 0})`}
                colors={sortedBgColor}
                keyPrefix="bg"
                threshold={field.threshold}
                threshold_value={threshold_value}
                hidden={field.hidden}
                showAll={showAll}
                showConfidence={field.showConfidence}
            />

            <hr className='Sidebar__list-color__divider' />

            <ColorContainer
                title={`All Colors (${sortedDominantColors.filter((color) => color.pixel_percentage >= threshold_value).length || 0})`}
                colors={sortedDominantColors}
                keyPrefix="dominant"
                threshold={field.threshold}
                threshold_value={threshold_value}
                hidden={field.hidden}
                showAll={showAll}
                showConfidence={field.showConfidence}
            />
        </div>
    )
}

interface ColorContainerProps {
    title: string
    colors: ColorItem[]
    keyPrefix: string
    threshold?: boolean
    threshold_value?: number
    hidden?: boolean,
    showAll?: boolean,
    showConfidence?: boolean
}

const ColorContainer = ({ title, colors, keyPrefix, threshold, threshold_value, hidden, showAll, showConfidence }: ColorContainerProps) => {
    return (
        <div className='Sidebar__list-color__container'>
            <div className='Sidebar__list-color__title-container'>
                <Paragraph text={title} variant='p3' variantStyle='bold' className='Sidebar__list-color__title' />
            </div>
            <div className='Sidebar__list-color__list-container'>
                {
                    colors?.map((color, index) => {
                        if (!showAll && hidden && color.pixel_percentage < threshold_value) {
                            return null;
                        }

                        return (
                            <DetectionListItem key={`${keyPrefix}-${index}`} item={color} showImage={false} thresholdValue={threshold_value} threshold={threshold} showConfidence={showConfidence} />
                        )
                    })
                }
            </div>
        </div>
    )
}

export default ListColor